export const createMockResponse = (data) => ({
    ok: true,
    json: () => Promise.resolve(data),
    text: () => Promise.resolve(JSON.stringify(data)),
    blob: () => Promise.resolve(new Blob([JSON.stringify(data)])),
});
export function getLogLevel() {
    const env = process.env.VCR_DEBUG;
    if (!env)
        return 0; // 0 means logging is off
    if (env === 'true' || env === '1')
        return 1;
    const n = parseInt(env, 10);
    if (!isNaN(n))
        return n;
    return 1;
}
export const debugLog = (...args) => {
    let level = 1;
    if (args.length > 1 && typeof args[args.length - 1] === 'number') {
        level = args.pop();
    }
    const message = args
        .flat()
        .map(arg => arg == null ? '' : String(arg))
        .join(' ');
    const currentLevel = getLogLevel();
    if (currentLevel === 0)
        return;
    if (currentLevel >= level) {
        console.log(message);
    }
};
